import { rem } from 'polished';
import styled from 'styled-components';
import { CheckoutPreOrderStyledOV } from '../CheckoutPreOrderStyled.OV';

export const CheckoutPreOrderStyledOVGB = styled(CheckoutPreOrderStyledOV)`
    .cashPaymentRejectedWrapper {
        padding: ${rem('20px')} ${rem('20px')};
        &_title {
            font-weight: 700;
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
            line-height: ${({ theme }) => theme.lineHeights.h5};
        }
        &_button {
            padding: ${rem('15px')};
            white-space: nowrap;
        }
    }
`;
